import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Container, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ModalBody from 'react-bootstrap/ModalBody';
import GenericList, { GenericListItem } from '../../../components/GenericList';
import Link from '../../../components/Link/Link';
import ModalHeader from '../../../components/ModalHeader';
import {
  addOrRemoveDaysToGivenDate,
  DateFormats,
  formatDate,
} from '../../../utils/utils';

export type customBenefitModalProps = {
  showBenefitModal: boolean;
  handleCloseBenefitModal: () => void;
};

const BenefitModal = ({
  showBenefitModal,
  handleCloseBenefitModal,
}: customBenefitModalProps) => {
  return (
    <Modal
      show={showBenefitModal}
      onHide={handleCloseBenefitModal}
      dialogClassName="modal-xl"
      className="custom-benefit-modal"
    >
      <ModalHeader closeButton withBorder>
        <h4 className="text-truncate">Benefit Information</h4>
      </ModalHeader>
      <ModalBody>
        <Container className="p-0">
          <Row className="pb-12">
            <Container className="d-flex justify-content-center img-wrapper">
              <img
                className="w-100"
                src={`${process.env.PUBLIC_URL}/${'benefit-img.svg'}`}
                alt="benefit-img"
              />
            </Container>
            <Container>
              <p>
                {`${formatDate(
                  new Date(),
                  DateFormats.ONLY_YEAR
                )} Annual Enrollment is your opportunity to enroll in or
                change your benefits coverage. Don't miss your chance to review
                and choose the plan that's best for you and your family. Be sure
                to make your elections starting ${formatDate(
                  new Date(),
                  DateFormats.DAY_MONTH_DATE
                )}, and no
                later than ${formatDate(
                  addOrRemoveDaysToGivenDate(new Date(), 28),
                  DateFormats.DAY_MONTH_DATE
                )} (11:59 p.m. ET).`}
              </p>
            </Container>
          </Row>
          <Row className="pb-12">
            <h5 className="pb-10">How to make elections</h5>
            <p className="bordered-paragraph">
              To elect a benefit, click its Change Button
            </p>
            <p className="bordered-paragraph">
              Then to enroll yourself or family member to coverage, check their
              name
            </p>
            <p className="bordered-paragraph">
              Once all elections are made, click Submit at the bottom of the
              page.
            </p>
          </Row>
          <Row className="pb-12">
            <h5 className="pb-10">
              Please note that eligible family members generally include:
            </h5>
            <p className="bordered-paragraph">
              Your spouse or domestic partner
            </p>
            <p className="bordered-paragraph">A child under the age of 26</p>
            <p className="bordered-paragraph">
              Your totally disabled, unmarried child who is incapable of
              self-sustaining employment by reason of mental retardation,
              physical handicap or mantal illness
            </p>
          </Row>
          <Row className="pb-12">
            <Container className="px-7 py-5 list-cointainer">
              <GenericList>
                <GenericListItem>
                  <Link
                    rightIcon={light('arrow-up-right-from-square')}
                    isBlue
                    isAlignAtEnd
                    eventKey="test"
                    href={`${
                      process.env.PUBLIC_URL
                    }/${'blank-demo-example.pdf'}`}
                  >
                    Additional Benefit Information
                  </Link>
                </GenericListItem>
                <GenericListItem>
                  <Link
                    rightIcon={light('arrow-up-right-from-square')}
                    isBlue
                    isAlignAtEnd
                    eventKey="test"
                    href={`${
                      process.env.PUBLIC_URL
                    }/${'blank-demo-example.pdf'}`}
                  >
                    Important Information
                  </Link>
                </GenericListItem>
                <GenericListItem>
                  <Link
                    rightIcon={light('arrow-up-right-from-square')}
                    isBlue
                    isAlignAtEnd
                    eventKey="test"
                    href={`${
                      process.env.PUBLIC_URL
                    }/${'blank-demo-example.pdf'}`}
                  >
                    Provider/Carrier Links
                  </Link>
                </GenericListItem>
                <GenericListItem>
                  <Link
                    rightIcon={light('arrow-up-right-from-square')}
                    isBlue
                    isAlignAtEnd
                    eventKey="test"
                    href={`${
                      process.env.PUBLIC_URL
                    }/${'blank-demo-example.pdf'}`}
                  >
                    Domestic Partner Fact Sheet
                  </Link>
                </GenericListItem>
              </GenericList>
            </Container>
          </Row>
        </Container>
      </ModalBody>
    </Modal>
  );
};

export default BenefitModal;
